import { createHashHistory } from 'history'
import moment from 'moment'
import AuthAPI from 'services/login'
import { notification } from 'antd'
import Scopes from 'services/scope'
import axios from 'axios'
import Conf from 'ui-config'
import { AES, enc } from 'crypto-js'
import ClusterService from './cluster_apis'

// import store from 'store'
import RouteAccess from './route_access'

export const Common = {
  version: 'v9.4.1',
  ktext: 'g1n93rGarl1cpa5t3',
  rtext: 't0mat0k3tchup5auc3',

  sortDataByTime: function(data, field) {
    let sorted_data = []
    sorted_data = data.sort((a, b) => parseFloat(b[field]) - parseFloat(a[field]))
    // console.log(sorted_data)
    return sorted_data
  },

  getAggregateValue: function(arrData, valField, zValue) {
    let p = 0,
      sum = 0
    let zValues = []
    for (p; p < arrData.length; p++) {
      sum = sum + arrData[p][valField]
      if (zValue !== null && zValues.indexOf(arrData[p][zValue]) === -1) {
        zValues[zValues.length] = arrData[p]
      }
      if (p === arrData.length - 1) {
        return { sum: sum, zValues: zValues }
      }
    }
  },

  getMaxUnit: function(arrData, valField, isByte) {
    var max = 0,
      unit = ''
    for (var i = 0; i < arrData.length; i++) {
      if (arrData[i][valField] !== null && arrData[i][valField] > max) {
        max = arrData[i][valField]
      }
      if (i === arrData.length - 1) {
        if (isByte) {
          if (max >= 1000000000000000) {
            unit = `P`
          } else if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `G`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = `B`
          }
        } else {
          if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `B`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = ``
          }
        }
        return unit
      }
    }
  },

  getMaxUnit2: function(arrData, valField, isByte) {
    var max = 0,
      unit = ''
    for (var i = 0; i < arrData.length; i++) {
      if (arrData[i][valField] > max) {
        max = arrData[i][valField]
      }
      if (i === arrData.length - 1) {
        if (isByte) {
          if (max >= 1000000000000000) {
            unit = `PB`
          } else if (max >= 1000000000000) {
            unit = `TB`
          } else if (max >= 1000000000) {
            unit = `GB`
          } else if (max >= 1000000) {
            unit = `MB`
          } else if (max >= 1000) {
            unit = `KB`
          } else {
            unit = `B`
          }
        } else {
          if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `B`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = ``
          }
        }
        return unit
      }
    }
  },

  bytesToSize: function(value, unit) {
    if (value !== undefined && value !== null) {
      if (unit === `P`) {
        return +((value / 1000000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000000).toFixed(4)
          : (value / 1000000000000000).toFixed(2))
      } else if (unit === `T`) {
        return +((value / 1000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000).toFixed(4)
          : (value / 1000000000000).toFixed(2))
      } else if (unit === `G`) {
        return +((value / 1000000000).toFixed(2) === '0.00'
          ? (value / 1000000000).toFixed(4)
          : (value / 1000000000).toFixed(2))
      } else if (unit === `M`) {
        return +((value / 1000000).toFixed(2) === '0.00'
          ? (value / 1000000).toFixed(4)
          : (value / 1000000).toFixed(2))
      } else if (unit === `K`) {
        return +((value / 1000).toFixed(2) === '0.00'
          ? (value / 1000).toFixed(4)
          : (value / 1000).toFixed(2))
      } else if (unit === `B`) {
        return +(value.toFixed(2) === '0.00' ? value.toFixed(4) : value.toFixed(2))
      }
    } else {
      return 0
    }
  },

  bytesToSize2: function(value, unit) {
    if (value !== undefined && value !== null) {
      if (unit === `PB`) {
        return +((value / 1000000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000000).toFixed(4)
          : (value / 1000000000000000).toFixed(2))
      } else if (unit === `TB`) {
        return +((value / 1000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000).toFixed(4)
          : (value / 1000000000000).toFixed(2))
      } else if (unit === `GB`) {
        return +((value / 1000000000).toFixed(2) === '0.00'
          ? (value / 1000000000).toFixed(4)
          : (value / 1000000000).toFixed(2))
      } else if (unit === `MB`) {
        return +((value / 1000000).toFixed(2) === '0.00'
          ? (value / 1000000).toFixed(4)
          : (value / 1000000).toFixed(2))
      } else if (unit === `KB`) {
        return +((value / 1000).toFixed(2) === '0.00'
          ? (value / 1000).toFixed(4)
          : (value / 1000).toFixed(2))
      } else if (unit === `B`) {
        return +(value.toFixed(2) === '0.00' ? value.toFixed(4) : value.toFixed(2))
      }
    }
  },

  convertNumber: function(value, unit) {
    if (value !== undefined && value !== null && unit !== undefined) {
      if (unit === `T`) {
        return +(value / 1000000000000).toFixed(2)
      } else if (unit === `B`) {
        return +(value / 1000000000).toFixed(2)
      } else if (unit === `M`) {
        return +(value / 1000000).toFixed(2)
      } else if (unit === `K`) {
        return +(value / 1000).toFixed(2)
      } else {
        return +value.toFixed(2)
      }
    } else {
      return 0
    }
  },

  formatNumber: function(labelValue) {
    // Nine Zeroes for Billions
    let val = ''
    if (Math.abs(Number(labelValue)) >= 1.0e9) {
      val = (Math.abs(Number(labelValue)) / 1.0e9).toString().slice(0, 4) + 'B'
    } else if (Math.abs(Number(labelValue)) >= 1.0e6) {
      val = (Math.abs(Number(labelValue)) / 1.0e6).toString().slice(0, 4) + 'M'
    } else if (Math.abs(Number(labelValue)) >= 1.0e3) {
      val = (Math.abs(Number(labelValue)) / 1.0e3).toString().slice(0, 4) + 'K'
    } else val = Math.abs(Number(labelValue))

    return val
  },

  getUnit: function(val) {
    if (val >= 1000000000000) {
      return +(val / 1000000000000).toFixed(1) + 'T'
    } else if (val >= 1000000000) {
      return +(val / 1000000000).toFixed(1) + 'B'
    } else if (val >= 1000000) {
      return +(val / 1000000).toFixed(1) + 'M'
    } else if (val >= 1000) {
      return +(val / 1000).toFixed(1) + 'K'
    } else {
      return val
    }
  },

  getNotesTime: function(data) {
    var timeStr = moment.unix(data).fromNow()
    return timeStr
  },

  getformatedTime: function(data, type) {
    var timeStr
    if (type === 'relative') {
      timeStr = moment(data)
        .startOf('ymd')
        .fromNow()
    } else if (type === 'relativeUTC') {
      timeStr = moment()
        .parseZone(data)
        .startOf('ymd')
        .fromNow()
    } else if (type === 'LongDate') {
      timeStr = moment(moment(new Date(data * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss')).format(
        'D MMM YYYY, h:mm A',
      )
    } else if (type === 'Last') {
      var num, str
      var seconds = new Date(data)?.getSeconds()
      var data = moment(data)
        .startOf('ymd')
        .fromNow()
      // str = data.replace('ago', '')
      // if (seconds === 0) {
      //   var minutes = new Date(data)?.getMinutes()
      //   if (minutes > 0) console.log('yes')
      //   console.log(data, minutes)
      // } else
      if (data === 'a few seconds ago') {
        timeStr = data
      } else if (data.includes('a ')) {
        str = data.replace('ago', '')
        num = 1
        str = str.replace('a', '')
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      } else if (data.includes('an ')) {
        str = data.replace('ago', '')
        num = 1
        str = str.replace('an', '')
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      } else {
        str = data.replace('ago', '')
        num = parseInt(data)
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      }
    } else if (type === 'MonthDayYear') {
      return moment(moment(new Date(data * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss')).format(
        'MMMM D, YYYY',
      )
    }
    return timeStr
  },

  getshortTime: function(data) {
    var timeStr = moment.unix(data).format('LT')
    return timeStr
  },

  getArrayDuration: function(starttime, endtime, partition) {
    var duration = 'minutes'
    partition ? (duration = partition) : (duration = 'minutes')
    var startStr = moment(moment(new Date(starttime * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss'))
    var endStr = moment(moment(new Date(endtime * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss'))
    var arr = []
    while (startStr.isBefore(endStr, duration)) {
      var formatData = new Date(startStr.format('D MMM YYYY, h:mm A'))
      arr.push({
        epocVal: formatData.getTime() / 1000.0,
        formattedTime: startStr.format('D MMM YYYY, h:mm A'),
      })
      startStr.add(1, duration)
    }
    return arr
  },

  convertTSToMilliSec: function(ts) {
    let ts_str = parseInt(ts) + ''

    let isMilliseconds = ts_str.length > 10

    return isMilliseconds ? ts : ts * 1000
  },

  encryptData: function(data, flag) {
    var convertedStr = flag ? data : JSON.stringify(data)
    var readyStr = AES.encrypt(this.ktext + convertedStr, this.rtext).toString()
    return readyStr
  },

  decryptData: function(ciphertext, flag) {
    if (ciphertext !== null) {
      var bytes = AES.decrypt(ciphertext, this.rtext)
      var decryptedData = bytes.toString(enc.Utf8)
      var data = decryptedData.substring(this.ktext.length, decryptedData.length)
      return flag ? data : JSON.parse(data)
    } else {
      return null
    }
  },

  exportData: async function(apiCall) {
    return await apiCall
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
          return null
        } else if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          } else {
            Common.showNotifications('error', 'Something went wrong')
          }
          return null
        } else {
          return response.data.data
        }
      })
      .catch(err => {
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
        return null
      })
  },

  sessionExpiry: function(val) {
    const history = createHashHistory()
    var status = localStorage.getItem('IsInvalid')
    if (history.location.pathname !== '/auth/login') {
      var historyURLmain = history.location.pathname + history.location.search
    } else {
    }
    localStorage.setItem('historyURL', historyURLmain)
    var userPayload = Common.decryptData(localStorage.getItem('userPayload'))
    if (userPayload === null) {
      setTimeout(() => {
        history.push('/auth/login')
      }, 100)
    }
    if (history.location.pathname !== '/auth/login') {
      status = false
    }
    if (history.location.pathname !== '/auth/login' && (status === false || status === 'false')) {
      localStorage.setItem('IsInvalid', true)
      localStorage.setItem('accessData', JSON.stringify([]))
      var ssid = localStorage.getItem('SSID')
      let input = {
        SSID: ssid,
      }
      if (val === 'access') {
        notification.error({
          message: 'Session expired. Redirecting to login',
          className: 'sessionOut',
        })
      }
      return AuthAPI.invalidate({
        SSID: ssid,
        clusterId: userPayload.selectedCluster.clusterId,
      })
        .then(response => {
          localStorage.setItem('SSID', '')
          localStorage.setItem('email', '')
          var historyURL = localStorage.getItem('historyURL')
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('historyURL', historyURL)

          // setTimeout(() => {
          //   history.push('/auth/login')
          // }, 100)

          return AuthAPI.logout(JSON.stringify(input))
            .then(response => {
              localStorage.setItem('SSID', '')
              localStorage.setItem('email', '')
              var historyURL = localStorage.getItem('historyURL')
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem('historyURL', historyURL)
            })
            .catch(err => {
              var historyURL = localStorage.getItem('historyURL')
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem('historyURL', historyURL)
              history.push('/auth/login')
            })
        })
        .catch(err => {
          localStorage.setItem('SSID', '')
          localStorage.setItem('email', '')
          var historyURL = localStorage.getItem('historyURL')
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('historyURL', historyURL)

          setTimeout(() => {
            history.push('/auth/login')
          }, 100)
        })
    }
  },
  showNotifications: function(status, msg, description) {
    return notification[status]({
      placement: 'bottomRight',
      // duration: status !== 'error' ? 4 : 0,
      duration: 4,
      message: msg,
      description: description ? description : '',
    })
  },
  copyText: function(text, msg) {
    navigator.clipboard.writeText(text)
    Common.showNotifications('info', msg !== undefined ? msg : 'Copied to clipboard')
  },
  generateTimeRange: function(startTime, endTime, timeslice) {
    var result = [moment(startTime)]
    while (startTime !== endTime) {
      var start = moment(startTime).add(1, timeslice)
      result.push(start)
    }
  },
  getScope: function() {
    let urlscope = window.location.hash.replace('#/', '').split('/')[1]
    let selectedScope = JSON.parse(sessionStorage.getItem('SelectedScope'))
    let SelectedCluster = this.getSelectedCluster()
    if (SelectedCluster !== null) {
      SelectedCluster['scope_access'].map(scope => {
        if (scope.scope_id === urlscope) {
          sessionStorage.setItem('SelectedScope', JSON.stringify(scope))
          selectedScope = scope
        }
      })
    }
    return selectedScope
  },
  getUserAcc: function(type) {
    let selectedCluster = {}
    let selectedScope = {}
    let accRole = ''
    var data = { ssid: localStorage.getItem('SSID') }
    if (localStorage.getItem('SSID') !== null) {
      Scopes.getUserAccessDetails(data, localStorage.getItem('SSID')).then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry()
        }
        if (response.data.status === 'success') {
          var responseData = response.data
          for (var i = 0; i < responseData.data.access.length; i++) {
            if (
              responseData.data.access[i].clusterId ===
              window.location.hash.replace('#/', '').split('/')[0]
            ) {
              selectedCluster = responseData.data.access[i]
              for (var j = 0; j < responseData.data.access[i].scope_access.length; j++) {
                if (
                  responseData.data.access[i].scope_access[j].scope_id ===
                  window.location.hash.replace('#/', '').split('/')[1]
                ) {
                  selectedScope = responseData.data.access[i].scope_access[j]
                }
              }
            } else {
              if (localStorage.getItem('IsInvalid') === false) {
                selectedCluster = responseData.data.access[0]
                selectedScope =
                  responseData.data.access[0].scope_access.length > 0
                    ? responseData.data.access[0].scope_access[0]
                    : {}
                break
              }
            }
          }
          var enabledScopelist = response.data.data
          for (var i = 0; i < enabledScopelist.access.length > 0; i++) {
            if (!enabledScopelist.isAdmin) {
              accRole = 'User - No Access'
              if (enabledScopelist.access[i].access_type !== 'No Access') {
                for (var j = 0; j < enabledScopelist.access[i].scope_access.length > 0; j++) {
                  if (
                    enabledScopelist.access[i].access_type === 'Custom' &&
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'User - ' + enabledScopelist.access[i].scope_access[j]['role']
                    break
                  } else if (
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'User - ' + enabledScopelist.access[i].access_type
                    break
                  } else {
                    accRole = 'User - No Access'
                  }
                }
              }
            } else {
              accRole = 'Admin - No Access'
              for (var j = 0; j < enabledScopelist.access[i].scope_access.length > 0; j++) {
                if (enabledScopelist.access[i].access_type !== 'No Access') {
                  if (
                    enabledScopelist.access[i].access_type === 'Custom' &&
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'Admin - ' + enabledScopelist.access[i].scope_access[j]['role']
                    break
                  } else if (
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'Admin - ' + enabledScopelist.access[i].access_type
                    break
                  } else {
                    accRole = 'Admin - No Access'
                  }
                }
              }
            }
          }
        }
      })
    }
    var userDetails = {
      Cluster: selectedCluster,
      Scope: selectedScope,
      UserAcc: accRole,
    }
    return userDetails
  },

  getSelectedCluster: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let selectedCluster = JSON.parse(sessionStorage.getItem('SelectedCluster'))

    let clusterData = this.getClusterData()
    if (clusterData !== null) {
      clusterData.map(cluster => {
        if (cluster.clusterId === urlclusterId) {
          sessionStorage.setItem('SelectedCluster', JSON.stringify(cluster))
          selectedCluster = cluster
        }
      })
    }

    return selectedCluster
  },

  getClusterData: function() {
    let clusterData = JSON.parse(sessionStorage.getItem('Clusters'))
    if (clusterData === null) {
      clusterData = JSON.parse(localStorage.getItem('Clusters'))
      sessionStorage.setItem('Clusters', JSON.stringify(clusterData))
    }
    return clusterData
  },

  getScopeList: function() {
    let scopeList = this.getSelectedCluster()
    if (scopeList !== null) {
      return scopeList['scope_access']
    } else {
      return scopeList
    }
  },
  getEnabledScopes: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let scopeList = JSON.parse(localStorage.getItem('EnabledScopes'))
    if (scopeList === null) {
      scopeList = JSON.parse(localStorage.getItem('EnabledScopes'))
      sessionStorage.setItem('EnabledScopes', JSON.stringify(scopeList))
    }
    return scopeList
  },
  getUserPayload: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let urlscope = window.location.hash.replace('#/', '').split('/')[1]
    let userPayload = Common.decryptData(localStorage.getItem('userPayload'))
    let clusterData = this.getClusterData()
    if (clusterData !== null) {
      clusterData.map(cluster => {
        if (cluster.clusterId === urlclusterId) {
          cluster['scope_access'].map(scope => {
            if (scope.scope_id === urlscope) {
              if (userPayload.role.includes('Admin')) {
                userPayload.role = 'Admin - ' + scope.role
              } else if (userPayload.role.includes('User')) {
                userPayload.role = 'User - ' + scope.role
              }
            }
          })
        }
      })
    }
    return userPayload
  },
  getPreURI: function() {
    var str = '/'
    if (
      window.location.hash.replace('#/', '').split('/')[0] !== '' &&
      window.location.hash.replace('#/', '').split('/')[0] !== 'admin'
    ) {
      str += window.location.hash.replace('#/', '').split('/')[0]
    }
    if (
      window.location.hash.replace('#/', '').split('/')[1] !== 'admin' &&
      window.location.hash.replace('#/', '').split('/')[0] !== 'admin'
    ) {
      str += '/' + window.location.hash.replace('#/', '').split('/')[1]
    }
    if (str === '/') {
      str = ''
    }
    return str
  },
  updateUserAccessAndClusterScope: getAccData => {
    var acc = getAccData.data
    var accArr = [],
      path = ''
    for (var i = 0; i < acc.data.access.length; i++) {
      accArr.push(acc.data.access[i])
    }
    acc.data.access = accArr
    let SelectedScope = {}
    let SelectedCluster = { scope_access: [], access_type: RouteAccess.NO_ACCESS }
    for (var i = 0; i < getAccData.data.data.access.length; i++) {
      if (getAccData.data.data.isRoot) {
        SelectedCluster = getAccData.data.data.access[i]
        break
      } else {
        var selectClus = {}
        for (let j = 0; j < getAccData.data.data.access[i].scope_access.length; j++) {
          if (getAccData.data.data.access[i].access_type === RouteAccess.ADMINISTRATOR) {
            selectClus = getAccData.data.data.access[i]
            break
          } else if (
            getAccData.data.data.access[i].scope_access[j].role !== RouteAccess.NO_ACCESS
          ) {
            selectClus = getAccData.data.data.access[i]
            break
          }
        }
        if (Object.keys(selectClus).length > 0) {
          SelectedCluster = selectClus
          break
        }
      }
    }
    var accRole = ''
    var Access = ''
    if (acc.data) {
      let enabledScopelist = acc.data
      let userRolePriority = {
        'No Access': 0,
        Viewer: 1,
        'Security Analyst': 2,
        'Security Engineer': 3,
      }
      let highestRole = ''
      if (!enabledScopelist.isRoot && !enabledScopelist.isOrgAdmin) {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
          }
        }
      } else if (enabledScopelist.isOrgAdmin) {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
          }
        }
      } else {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
          }
        }
      }
    }
    localStorage.setItem('UserAcc', Common.encryptData(accRole, true))
    const userPayload = Common.decryptData(localStorage.getItem('userPayload'))
    userPayload.licenseType =
      Object.keys(SelectedCluster).length > 0 ? SelectedCluster.licenseType : ''
    userPayload.clusterId = Object.keys(SelectedCluster).length > 0 ? SelectedCluster.clusterId : ''
    userPayload.scope_id = Object.keys(SelectedScope).length > 0 ? SelectedScope.scope_id : ''
    userPayload.selectedCluster = SelectedCluster
    userPayload.selectedScope = SelectedScope
    userPayload.AllAccessData = getAccData.data
    userPayload.role = accRole

    localStorage.setItem('userPayload', Common.encryptData(userPayload))

    const history = createHashHistory()
    localStorage.setItem('userPayload', Common.encryptData(userPayload))
    var historyURLpath = localStorage.getItem('historyURL')
    if (Object.keys(SelectedCluster).length > 0 || Object.keys(SelectedScope).length > 0) {
      var scopeID = Object.keys(SelectedScope).length > 0 ? '/' + SelectedScope.scope_id : ''
      if (!RouteAccess.USER_NO_ACCESS_ROLES.includes(accRole)) {
        if (RouteAccess.ROOT_INIT_ROLES.includes(accRole)) {
          path = '/admin/tenants/list'
        } else if (RouteAccess.ROOT_NO_ACCESS_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/admin/tenants/list'
        } else if (RouteAccess.ORG_ADMIN_NO_ACCESS_ROLES.includes(accRole)) {
          path = '/admin/organizations/list'
        } else if (RouteAccess.ONLY_TENANT_ADMIN_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/admin/tenants/list'
        } else if (RouteAccess.VIEWER_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
        } else {
          path =
            '/' +
            SelectedCluster.clusterId +
            scopeID +
            '/home' +
            scopeID +
            '/' +
            SelectedCluster.clusterId
        }
      } else {
        path = '/no-access/auth/no-access'
      }
    } else {
      path = '/no-access/auth/no-access'
    }
    if (history.location.pathname !== path) {
      history.push(path)
      window.location.reload(false)
    }
  },
  UpdateUI_withNewAccess: function() {
    const history = createHashHistory()
    var data = { ssid: localStorage.getItem('SSID') }
    if (localStorage.getItem('SSID') !== null) {
      Scopes.getUserAccessDetails(data, localStorage.getItem('SSID')).then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        } else if (response.data.status === 'failed') {
          Common.showNotifications('error', 'Something went wrong')
        } else if (response.data.status === 'success') {
          var Access = 'No Access'
          if (response.data.data.access.length > 0) {
            var accRole = ''
            var SelectedScope =
              response.data.data.access[0]['scope_access'].length > 0
                ? response.data.data.access[0]['scope_access'][0]
                : {}
            var SelectedCluster = response.data.data.access[0]
            var enabledScopelist = response.data.data
            for (var i = 0; i < response.data.data.access.length; i++) {
              if (response.data.data.isAdmin) {
                SelectedCluster = response.data.data.access[i]
                break
              } else {
                var selectClus = {}
                for (var j = 0; j < response.data.data.access[i].scope_access.length; j++) {
                  if (response.data.data.access[i].access_type === 'Custom') {
                    if (response.data.data.access[i].scope_access[j].role !== 'No Access') {
                      selectClus = response.data.data.access[i]
                      break
                    }
                  } else {
                    selectClus = response.data.data.access[i]
                    break
                  }
                }
                if (Object.keys(selectClus).length > 0) {
                  SelectedCluster = selectClus
                  break
                }
              }
            }
            if (!enabledScopelist.isAdmin) {
              if (SelectedCluster.scope_access.length > 0) {
                if (SelectedCluster.access_type !== 'No Access') {
                  for (var j = 0; j < SelectedCluster.scope_access.length > 0; j++) {
                    if (SelectedCluster.access_type !== 'No Access') {
                      if (SelectedCluster.access_type === 'Administrator') {
                        accRole = 'User - SecAdmin ' + SelectedCluster.scope_access[j]['role']
                      } else {
                        accRole = 'User - ' + SelectedCluster.scope_access[j]['role']
                      }
                      SelectedScope = SelectedCluster.scope_access[j]
                      Access = accRole
                      break
                    } else if (SelectedCluster['scope_access'][j]['role'] !== 'No Access') {
                      accRole = 'User - ' + SelectedCluster.access_type
                      SelectedScope = SelectedCluster.scope_access[j]
                      Access = accRole
                      break
                    } else {
                      accRole = 'User - No Access'
                    }
                  }
                }
              } else {
                if (
                  SelectedCluster.scope_access.length === 0 &&
                  accRole === '' &&
                  SelectedCluster.access_type !== 'Custom'
                ) {
                  accRole = 'User - No Access'
                } else {
                  if (
                    SelectedCluster.access_type === 'Custom' &&
                    SelectedCluster.scope_access.length === 0
                  ) {
                    accRole = 'User - No Access'
                  }
                }
              }
            } else {
              if (SelectedCluster.scope_access.length > 0) {
                for (var j = 0; j < SelectedCluster.scope_access.length > 0; j++) {
                  if (SelectedCluster.access_type !== 'No Access') {
                    if (SelectedCluster.access_type === 'Administrator') {
                      accRole = 'Admin - SecAdmin ' + SelectedCluster.scope_access[j]['role']
                      SelectedScope = SelectedCluster.scope_access[j]
                      Access = accRole
                      break
                    } else if (
                      SelectedCluster.access_type === 'Custom' &&
                      SelectedCluster['scope_access'][j]['role'] !== 'No Access'
                    ) {
                      accRole = 'Admin - ' + SelectedCluster.scope_access[j]['role']
                      SelectedScope = SelectedCluster.scope_access[j]
                      Access = accRole
                      break
                    } else if (SelectedCluster['scope_access'][j]['role'] !== 'No Access') {
                      accRole = 'Admin - ' + SelectedCluster.access_type
                      SelectedScope = SelectedCluster.scope_access[j]
                      Access = accRole
                      break
                    } else {
                      accRole = 'Admin - No Access'
                    }
                  }
                }
              } else {
                if (
                  SelectedCluster.scope_access.length === 0 &&
                  accRole === '' &&
                  SelectedCluster.access_type !== 'Custom'
                ) {
                  accRole = 'Admin - No Access'
                } else {
                  if (
                    SelectedCluster.access_type === 'Custom' &&
                    SelectedCluster.scope_access.length === 0
                  ) {
                    accRole = 'Admin - No Access'
                  }
                }
              }
            }

            localStorage.setItem('UserAcc', Common.encryptData(accRole, true))
            const userPayload = Common.decryptData(localStorage.getItem('userPayload'))
            userPayload.licenseType =
              Object.keys(SelectedCluster).length > 0 ? SelectedCluster.licenseType : ''
            userPayload.clusterId =
              Object.keys(SelectedCluster).length > 0 ? SelectedCluster.clusterId : ''
            userPayload.scope_id =
              Object.keys(SelectedScope).length > 0 ? SelectedScope.scope_id : ''
            userPayload.selectedCluster = SelectedCluster
            userPayload.selectedScope = SelectedScope
            userPayload.AllAccessData = response.data

            localStorage.setItem('userPayload', Common.encryptData(userPayload))
            var path = ''
            if (Object.keys(SelectedCluster).length > 0 || Object.keys(SelectedScope).length > 0) {
              var scopeID =
                Object.keys(SelectedScope).length > 0 ? '/' + SelectedScope.scope_id : ''
              if (accRole !== 'User - No Access') {
                if (accRole === 'Admin - No Access') {
                  path = '/' + SelectedCluster.clusterId + scopeID + '/admin/components'
                } else if (accRole === 'User - Viewer' || accRole === 'Admin - Viewer') {
                  path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
                } else {
                  path =
                    '/' +
                    SelectedCluster.clusterId +
                    scopeID +
                    '/home' +
                    scopeID +
                    '/' +
                    SelectedCluster.clusterId
                }
              } else {
                path = '/no-access/auth/no-access'
              }
            } else {
              path = '/no-access/auth/no-access'
            }
            if (history.location.pathname !== path) {
              history.push(path)
              window.location.reload(false)
            }
          }
        }
      })
    }
  },
  exportData: async function(apiCall) {
    return await apiCall
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
          return null
        } else if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          } else {
            Common.showNotifications('error', 'Something went wrong')
          }
          return null
        } else {
          return response.data.data
        }
      })
      .catch(err => {
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
        return null
      })
  },
  checkSessionExpiry: function() {
    let ssid = localStorage.getItem('SSID')
    var data = { ssid: ssid }
    Scopes.getUserAccessDetails(data, ssid)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry('access')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'invalid' ||
            (error.response.data.status === 'error' &&
              error.response.data.message.indexOf('Invalid') > -1)
          ) {
            Common.sessionExpiry('access')
          }
        }
      })
  },
  searchList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/search', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  usersList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/users/list', params, {
      headers: { SSID: ssid },
    })
  },
}
export default Common
